export const PAYMENT_FAIL_START = 'PAYMENT_FAIL_START';
export const PAYMENT_FAIL_SUCCESS = 'PAYMENT_FAIL_SUCCESS';
export const PAYMENT_FAIL_FAIL = 'PAYMENT_FAIL_FAIL';
export const PAYMENT_FAIL_RESET = 'PAYMENT_FAIL_RESET';
